
export class MenuItem {
	constructor(public title: string, public route: string, public icon: string | undefined, public svgIcon: boolean | undefined, public children: MenuItem[] = []
	) { }
}
